import crmApi from "./http-client";

export const callRefreshService = () => {
	const url = "/auth/refresh";
	return crmApi.get(url, {
		withCredentials: "include"
	});
};
export const loginAuthService = (payload) => {
	const url = "/auth/login";
	return crmApi.post(url, payload);
};
export const userDetailsService = () => {
	const url = "/settings/user-profile/detail";
	return crmApi.get(url);
};
export const logoutService = () => {
	const url = "/auth/logout";
	return crmApi.post(url);
};
